// @flow
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import { responsiveStoreEnhancer } from 'redux-responsive';

import mapFeatureMiddleware from 'utils/mapFeature.middleware';
import preserveURLHashMiddleware from 'utils/preserveURLHash.middleware';
import authMiddleware from 'utils/auth.middleware';

import rootReducer from './reducers';

export const history = createHistory();
export const INIT_ACTION_TYPE = '@@LEGTER_HU/init';

export default function() {
  const store = createStore(
    rootReducer,
    compose(
      applyMiddleware(
        preserveURLHashMiddleware,
        routerMiddleware(history),
        thunk,
        mapFeatureMiddleware,
        authMiddleware
      ),
      responsiveStoreEnhancer,

      // eslint-disable-next-line no-underscore-dangle
      ...(window.__REDUX_DEVTOOLS_EXTENSION__ &&
      process.env.FE_NODE_ENV === 'development'
        ? // eslint-disable-next-line no-underscore-dangle
          [window.__REDUX_DEVTOOLS_EXTENSION__()]
        : [])
    )
  );

  store.dispatch({ type: INIT_ACTION_TYPE });
  return store;
}



// WEBPACK FOOTER //
// ./store.js